import React from 'react';

class Config {

    constructor() {
        this.images = [];
    }

    getBaseUrl() {
        if (window.location.hostname.indexOf('localhost') >-1) {
            //Change to localhost image repo
            return "https://beta.assets.languagenut.com/";
        } else if (window.location.hostname.indexOf('beta') >-1) {
            return "https://beta.assets.languagenut.com/";
        } else {
            return "https://assets.languagenut.com/";
        }
    }

    getAudioBaseUrl() {
        if (window.location.hostname.indexOf('localhost') >-1) {
            //Change to localhost image repo
            return "https://beta.assets.languagenut.com/";
        } else if (window.location.hostname.indexOf('beta') >-1) {
            return "https://beta.assets.languagenut.com/";
        } else {
            return "https://assets.languagenut.com/vocabs/";
        }
    }

    getImagePath(){
        return this.getAudioBaseUrl().replace(/\/$/, "") + (window.location.hostname.indexOf('localhost') >-1 ? "/vocabs/" : "/");
    }

    isLive() {
        return window.location.hostname.indexOf('localhost') == -1 && window.location.hostname.indexOf('beta') == -1;
    }
}

export default new Config();




// WEBPACK FOOTER //
// ./src/classes/config.js